<template>
    <div>
        <wap-header></wap-header>
        <div style="background: #ffffff" class="wapDynamics">
            <div class="wapTabs">
                <div class="wapTitle">
                    <div :class="activeName==1?'active':''"  @click="btn_tab(1)">
                        <span>行业资讯</span>
                    </div>
                    <div :class="activeName==2?'active':''"  @click="btn_tab(2)">
                        <span>公司动态</span>
                    </div>
                </div>
<!--                <el-tab-pane label="行业资讯" name="1">-->
                <div class="wapInformationBox" v-if="activeName == '1'">
                    <div class="li" v-for="item in data2" :key="item.id"  @click="to_detail(item.id)">
                        <div class="left">
                            <img v-if="item.listImg" :src="'../../../static/image/information/'+item.listImg">
                            <img v-else src="@/assets/image/default.png" />
                        </div>
                        <div class="right">
                            <div class="name">{{item.title}}</div>
                            <div class="subtitle">{{item.subtitle}}</div>
                            <div class="time">{{item.time}}</div>
                        </div>    <div style="clear: both"></div>
                    </div>
                </div>
<!--                </el-tab-pane>-->
<!--                <el-tab-pane label="公司动态" name="2">-->
                <div class="wapInformationBox" v-if="activeName == '2'">
                    <div class="li" v-for="item in data1" :key="item.id" @click="to_detail(item.id)">
                        <div class="left">
                            <img v-if="item.listImg" :src="'../../../static/image/information/'+item.listImg"/>
                            <img src="@/assets/image/default.png" v-else  />
                        </div>
                        <div class="right">
                            <div class="name">{{item.title}}</div>
                            <div class="subtitle">{{item.subtitle}}</div>
                            <div class="time">{{item.time}}</div>
                        </div>    <div style="clear: both"></div>
                    </div>
                </div>
<!--                </el-tab-pane>-->
            </div>
        </div>
        <wap-footer></wap-footer>
    </div>
</template>
<script>
    import wapHeader from "@/components/wap/headers";
    import wapFooter from "@/components/wap/footers";
    export default {
        name: "informarionWap",
        components: {wapHeader, wapFooter},
        data() {
            return {
                activeName:"1",
                data1:[],
                data2:[]
            }
        },
        watch:{
            '$route': function (to, from) {
                if(this.$route.query.type){
                    this.activeName = this.$route.query.type;
                }
            }
        },
        mounted() {
            this.data1 =require('../../../assets/JSONData/Information/company.json');
            this.data2 =require('../../../assets/JSONData/Information/InformationDynamics.json');
            if (this.$route.query.type) {
                this.activeName =this.$route.query.type;
            }
        },
        methods: {
            to_detail(id){
                // this.$router.push('/InformationDynamicsDetail?id='+id);
                let pathName =  window.location.pathname;
                if(pathName ==` '/InformationDynamicsDetail?id='+id&wapShow=true`)return;
                this.$router.push({
                    path:'/InformationDynamicsDetail?id='+id,
                    query:{wapShow:true}
                });
            },
            btn_tab(index) {
                this.activeName = index;
            }
        }
    }
</script>
<style scoped>
    .wapDynamics{
        width:390px;
        height:100%;
        margin:55px auto 0;
    }
    .wapDynamics .wapTabs{
        width:355px;
        margin:0 auto;
    }
    .wapDynamics .wapTabs .wapTitle{
        width: 355px;
        height: 46px;
        margin: 0 auto 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #007ED2;
        border-radius: 10px 10px 0 0;
    }
    .wapDynamics .wapTabs .wapTitle div{
        width: 50%;
        height: 46px;
        line-height: 46px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #FFFFFF;
        text-align: center;
        border-radius: 10px 10px 0 0;
    }
    .wapDynamics .wapTabs .wapTitle .active{
        background: rgba(0, 0, 0, 0.42);
        border-radius: 10px 10px 0 0;
    }
    .wapDynamics .wapTabs .wapInformationBox{
        margin-bottom:20px;
    }
    .wapDynamics .wapTabs .wapInformationBox .li{
        width:355px;
        height:71px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e6e8eb;
        position: relative;
        cursor: pointer;
        margin:0 auto 10px;
    }
    .wapInformationBox .li .left img{
        width:150px;
        height:70px;
        border-radius: 10px;
    }
    .wapInformationBox .li .left{
        display: inline-block;
    }
    .wapInformationBox .li .right{
        width:193px;
        height:71px;
        float: right;
        display: inline-block;
    }
    .wapInformationBox .li .right .name{
        width: 193px;
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #363A44;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom:2px;
    }
    .wapInformationBox .li .right .subtitle{
        width: 193px;
        height: 34px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
        overflow: hidden;
        margin-bottom:4px;
    }
    .wapInformationBox .li .right .time{
        width: 193px;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
    }
</style>
